import script from "./VacancyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyItem.vue?vue&type=script&setup=true&lang=js"

import "./VacancyItem.vue?vue&type=style&index=0&id=c890a0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c890a0ea"]])

export default __exports__